<template>
  <div v-if="isMounted" style="width: 100%">
    <svg :height="height" :width="width" viewBox="120 0 1500 3000" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1544.42 57.9088C1544.42 42.8275 1548.19 25.2325 1550.08 18.3202L1289.75 17C1284.94 31.6186 1273.68 65.2107 1267.05 82.6303C1258.77 104.405 1211.55 144.274 1204.18 155.928C1196.82 167.582 1165.85 202.85 1155.42 212.664C1144.99 222.478 1124.75 243.332 1117.09 266.64C1110.95 285.287 1091.64 310.831 1082.74 329.232L1042.74 377.232C1033.24 407.676 990.426 444.517 989.199 454.331C987.666 466.598 994.72 487.759 1019.25 491.44C1043.79 495.12 1076.3 474.572 1096.54 458.624C1112.73 445.866 1125.21 419.343 1129.43 407.676L1147.27 388.871L1167.37 374.368C1176.27 367.939 1188.65 374.774 1187.94 385.738C1186.85 402.816 1185.72 420.465 1185.36 426C1184.64 437.091 1178.85 521.717 1177.16 534.737C1175.81 545.152 1168.74 574.568 1166.24 589.732L1166.1 590.621C1163.56 606.029 1158.81 634.808 1158.24 645.402C1155.24 658.232 1151.74 688.205 1151.74 694.232C1151.74 700.26 1146.06 764.747 1145.1 781.141C1144.13 797.536 1149.2 811.038 1161.97 816.824C1174.75 822.611 1197.66 819.235 1206.1 812.726C1212.85 807.518 1216.94 778.57 1218.15 764.747L1227.79 719.179C1231.57 700.935 1239.32 663.87 1240.09 661.555C1240.86 659.241 1249.02 618.479 1254.24 599.834C1255.93 589.949 1262.66 568.298 1266.13 549.203C1268.8 534.514 1272.76 526.76 1279.4 522.734C1282.63 520.776 1286.31 523.537 1286.39 527.313C1286.93 553.01 1284.95 593.828 1284.24 598.732C1283.47 604.133 1281.74 627.232 1281.74 643.232C1281.74 665.232 1276.98 707.732 1276.98 720.866C1276.98 735.732 1273.26 759.794 1273.74 768.232C1274.23 776.671 1271.67 839.006 1279.39 862.392C1287.11 885.779 1322.3 884.305 1337.24 872.732C1352.19 861.16 1351.77 807.421 1359.24 775.837C1365.24 744.232 1364.24 727.366 1364.24 720.866C1364.24 714.366 1364.98 704.712 1366.91 683.978C1368.84 663.243 1374 617.675 1374.24 608.272C1374.49 598.869 1378 554.989 1378 551.131C1378 547.274 1383.79 523.646 1394.15 524.61C1404.52 525.575 1409.34 542.452 1411.03 547.997C1412.72 553.542 1415.85 594.061 1415.85 604.897C1415.85 615.732 1417.03 646.282 1419.24 660.109C1421.46 673.936 1424.31 711.266 1426.24 725.732C1427.59 735.794 1428.82 765.97 1430.74 792.732C1431.92 809.105 1431.91 826.922 1441.24 837.732C1447.17 844.593 1460.87 848.034 1468.17 848.409C1483.22 849.18 1495.21 836.323 1498.74 829.732C1501.08 815.668 1504.74 776.152 1504.74 766.732C1504.74 755.642 1505.4 731.216 1504.74 718.214C1503.74 698.232 1501.58 669.169 1501.58 655.769C1501.58 643.232 1497.47 583.153 1496.74 574.232C1496.17 567.094 1497.36 537.908 1499.1 516.894C1499.48 512.232 1504.61 511.29 1506.37 515.626C1513.49 533.24 1522.34 561.634 1523.62 572.107C1525.31 585.85 1538.57 637.445 1538.57 656.975C1538.57 676.504 1540.02 690.488 1546.05 715.321C1552.07 740.154 1569.69 739.232 1581.74 739.232C1589.28 739.232 1599.38 733.471 1605.91 725.434C1609.46 721.065 1610.46 715.304 1610.27 709.679C1609.57 688.502 1606.71 665.198 1607.05 660.109C1607.43 654.323 1604.47 631.659 1602.95 621.051C1602.14 605.861 1600.58 573.843 1600.78 567.285C1601.02 559.088 1599.09 539.57 1591.55 506.579C1584.01 473.589 1581.18 426 1581.18 388.871C1581.18 345.256 1579.3 299.21 1581.18 281.301C1583.07 263.392 1581.18 242.232 1573.64 209.665C1570.79 197.345 1555.73 140.856 1555.73 132.373C1555.73 123.89 1544.42 76.7605 1544.42 57.9088Z"
        fill="#D6D6D6"
        stroke="#FF4646"
        stroke-width="9"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo2quiroE)"
        @mouseover="activeArea = areas.dedo2quiroE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo2quiroE.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo2quiroE.selected, hovered: activeArea == areas.dedo2quiroE }"
        class="ax-selectable"
        d="M1280.16 518C1293.36 427.6 1223.32 387.667 1186.66 379C1191.86 389.8 1190.16 417.5 1188.66 430L1181.66 531.5C1179.82 541.5 1175.76 562.9 1174.16 568.5C1172.56 574.1 1165.16 619.833 1161.66 642L1156.16 688L1155.16 699C1153.49 723.333 1149.96 773.5 1149.16 779.5C1148.16 787 1149.66 791.5 1152.16 800.5C1154.66 809.5 1165.66 813.5 1174.66 814.5C1183.66 815.5 1200.16 813 1205.16 808C1209.16 804 1213.16 784.667 1214.66 775.5L1216.16 759L1231.66 686L1245.66 622.5L1256.66 576C1259.66 564.5 1266.06 539.8 1267.66 533C1269.66 524.5 1274.16 526 1280.16 518Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo4quiroE)"
        @mouseover="activeArea = areas.dedo4quiroE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo4quiroE.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo4quiroE.selected, hovered: activeArea == areas.dedo4quiroE }"
        class="ax-selectable"
        d="M1498.66 512C1454.26 442.8 1416.49 491.833 1403.16 525C1410.36 530.6 1414.49 543 1415.66 548.5L1419.16 590.5L1421.16 642L1425.16 671.5L1429.16 710.5L1431.16 729C1432.66 752.833 1435.76 802.6 1436.16 811C1436.66 821.5 1440.66 828 1443.66 832.5C1450.16 841 1465.16 843 1471.16 843C1485.56 840.6 1493.49 831 1495.66 826.5C1496.82 817.333 1499.26 797 1499.66 789C1500.86 781 1501.49 765.333 1501.66 758.5V719L1499.66 687L1497.16 632C1496.16 613.167 1494.06 573.4 1493.66 565C1493.16 554.5 1496.66 520.5 1498.66 512Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo5quiroE)"
        @mouseover="activeArea = areas.dedo5quiroE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo5quiroE.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo5quiroE.selected, hovered: activeArea == areas.dedo5quiroE }"
        class="ax-selectable"
        d="M1507.16 509.5C1516.36 443.5 1562.66 460.333 1584.66 477L1594.16 526.5L1597.66 553L1599.66 607C1600.99 619.5 1603.76 645.8 1604.16 651C1604.66 657.5 1608.16 710 1606.66 718C1604.16 725.5 1592.66 731.5 1588.66 733.5C1584.66 735.5 1568.66 735.5 1561.16 731.5C1553.66 727.5 1552.16 720 1547.16 703C1543.16 689.4 1541.82 669.667 1541.66 661.5V642.5L1525.66 564C1520.66 548.5 1509.96 515.9 1507.16 509.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo3quiroE)"
        @mouseover="activeArea = areas.dedo3quiroE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo3quiroE.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo3quiroE.selected, hovered: activeArea == areas.dedo3quiroE }"
        class="ax-selectable"
        d="M1387.66 525.5C1357.26 452.3 1307.32 492 1286.16 521C1288.96 521.8 1289.99 536.667 1290.16 544L1286.66 604.5L1285.66 656.5L1280.66 720.5L1278.16 764V818C1278.16 828.5 1280.66 850 1283.16 858.5C1285.66 867 1292.16 873.5 1304.16 875C1316.16 876.5 1330.16 874 1337.66 866C1343.66 859.6 1348.16 830.333 1349.66 816.5L1352.66 791.5C1355.66 776.167 1361.66 744.7 1361.66 741.5V714L1366.66 659.5L1370.66 609.5C1372.16 590.333 1375.16 551.1 1375.16 547.5C1375.16 543 1377.66 541 1387.66 525.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo1quiroE)"
        @mouseover="activeArea = areas.dedo1quiroE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo1quiroE.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo1quiroE.selected, hovered: activeArea == areas.dedo1quiroE }"
        class="ax-selectable"
        d="M1177.16 368.5C1205.16 310.1 1154.82 263.833 1126.16 248L1085.66 328L1045.66 377C1044.16 380.667 1040.86 388.9 1039.66 392.5C1038.16 397 995.158 443.5 992.658 450.5C990.158 457.5 988.658 467 1002.16 478.5C1015.66 490 1022.16 487.5 1037.16 485.5C1052.16 483.5 1081.16 466 1102.16 448.5C1120.16 431.3 1126.32 412.333 1127.16 405C1130.99 400.833 1140.06 391.2 1145.66 386C1152.53 379.622 1161.32 375.651 1176.29 368.891L1177.16 368.5Z"
      />
      <path
        d="M1343.01 816.742C1322.85 796.946 1296.78 804.71 1286.26 811.067V862.375C1298.79 872.364 1322.36 870.623 1332.57 868.504C1336.05 856.018 1343.01 828.184 1343.01 816.742Z"
        fill="#AAAAAA"
      />
      <path
        d="M1211.66 759.175C1191.51 739.378 1167.76 747.146 1156.67 753.897C1154.91 766.916 1154.91 791.266 1154.91 804.806V804.807C1167.44 814.796 1191.01 813.056 1201.22 810.937C1204.7 798.45 1211.66 770.617 1211.66 759.175Z"
        fill="#AAAAAA"
      />
      <path
        d="M1495.16 783.077C1472.74 765.891 1449.58 775.483 1439.92 783.077C1438.54 796.099 1438.54 817.999 1443.27 831.612C1456.93 839.996 1479.2 836.401 1489.08 833.05C1491.01 820.232 1495.16 795.309 1495.16 783.077Z"
        fill="#AAAAAA"
      />
      <path
        d="M1600.91 681.954C1580.18 670.398 1561.1 680.565 1553.45 687.71C1553.37 698.38 1555.23 716.082 1560.46 726.593C1572.91 731.946 1591.74 726.72 1599.94 722.982C1600.51 712.42 1601.95 691.841 1600.91 681.954Z"
        fill="#AAAAAA"
      />
      <path
        d="M1040.04 412.649C1042.95 406.834 1041.25 399.11 1040.04 395.975L991.087 454.335C992.94 456.472 997.329 460.748 1000.07 460.748C1003.49 460.748 1036.41 419.917 1040.04 412.649Z"
        fill="#AAAAAA"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha5quiroE)"
        @mouseover="activeArea = areas.unha5quiroE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha5quiroE.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha5quiroE.selected, hovered: activeArea == areas.unha5quiroE }"
        class="ax-selectable"
        r="44"
        transform="matrix(-1 0 0 1 1602 751)"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha4quiroE)"
        @mouseover="activeArea = areas.unha4quiroE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha4quiroE.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha4quiroE.selected, hovered: activeArea == areas.unha4quiroE }"
        class="ax-selectable"
        r="44"
        transform="matrix(-1 0 0 1 1472 863)"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha3quiroE)"
        @mouseover="activeArea = areas.unha3quiroE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha3quiroE.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha3quiroE.selected, hovered: activeArea == areas.unha3quiroE }"
        class="ax-selectable"
        r="44"
        transform="matrix(-1 0 0 1 1303 887)"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha2quiroE)"
        @mouseover="activeArea = areas.unha2quiroE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha2quiroE.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha2quiroE.selected, hovered: activeArea == areas.unha2quiroE }"
        class="ax-selectable"
        r="44"
        transform="matrix(-1 0 0 1 1158 825)"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha1quiroE)"
        @mouseover="activeArea = areas.unha1quiroE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha1quiroE.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha1quiroE.selected, hovered: activeArea == areas.unha1quiroE }"
        class="ax-selectable"
        r="44"
        transform="matrix(-1 0 0 1 970 446)"
        stroke="#0081F9"
        stroke-width="12"
      />
      <path
        d="M104.323 46.1764C104.323 31.095 100.553 13.5001 98.6679 6.58782L358.996 5.26758C363.8 19.8862 375.066 53.4782 381.69 70.8979C389.971 92.6724 437.2 132.541 444.56 144.195C451.921 155.849 482.896 191.118 493.323 200.932C503.75 210.746 523.991 231.6 531.658 254.908C537.792 273.554 557.106 299.099 566 317.5L606 365.5C615.5 395.944 658.319 432.784 659.545 442.598C661.079 454.866 654.025 476.027 629.49 479.707C604.956 483.387 572.447 462.839 552.206 446.892C536.013 434.134 523.535 407.611 519.32 395.944L501.478 377.138L481.379 362.635C472.471 356.207 460.099 363.042 460.8 374.005C461.893 391.084 463.023 408.732 463.384 414.268C464.107 425.358 469.894 509.985 471.582 523.004C472.932 533.42 480 562.836 482.5 578L482.646 578.888C485.187 594.297 489.932 623.075 490.5 633.669C493.5 646.5 497 676.472 497 682.5C497 688.528 502.684 753.014 503.648 769.409C504.612 785.804 499.549 799.305 486.771 805.092C473.993 810.878 451.088 807.503 442.65 800.993C435.899 795.785 431.8 766.837 430.594 753.014L420.95 707.446C417.173 689.203 409.426 652.138 408.654 649.823C407.883 647.508 399.724 606.746 394.5 588.101C392.812 578.216 386.087 556.565 382.615 537.47C379.945 522.782 375.989 515.028 369.346 511.001C366.116 509.043 362.437 511.804 362.357 515.581C361.814 541.277 363.799 582.096 364.5 587C365.272 592.401 367 615.5 367 631.5C367 653.5 371.766 696 371.766 709.134C371.766 724 375.482 748.061 375 756.5C374.518 764.939 377.07 827.273 369.355 850.66C361.64 874.047 326.448 872.573 311.5 861C296.552 849.427 296.974 795.689 289.5 764.105C283.5 732.5 284.5 715.634 284.5 709.134C284.5 702.634 283.764 692.98 281.835 672.245C279.907 651.511 274.741 605.943 274.5 596.54C274.259 587.137 270.745 543.257 270.745 539.399C270.745 535.541 264.958 511.913 254.591 512.878C244.224 513.842 239.402 530.719 237.714 536.265C236.026 541.81 232.892 582.329 232.892 593.164C232.892 604 231.712 634.55 229.5 648.376C227.288 662.203 224.44 699.534 222.5 714C221.151 724.062 219.929 754.238 218 781C216.82 797.372 216.835 815.189 207.5 826C201.576 832.86 187.874 836.302 180.573 836.676C165.528 837.448 153.536 824.59 150 818C147.669 803.936 144 764.42 144 755C144 743.909 143.349 719.484 144 706.482C145 686.5 147.167 657.437 147.167 644.037C147.167 631.5 151.277 571.421 152 562.5C152.579 555.362 151.384 526.175 149.648 505.162C149.263 500.5 144.132 499.557 142.378 503.893C135.253 521.508 126.406 549.902 125.12 560.375C123.432 574.117 110.172 625.713 110.172 645.242C110.172 664.771 108.725 678.755 102.698 703.589C96.67 728.422 79.0551 727.5 67 727.5C59.4678 727.5 49.3662 721.738 42.8373 713.701C39.2883 709.332 38.2888 703.572 38.4738 697.946C39.1702 676.77 42.0383 653.465 41.699 648.376C41.3133 642.59 44.2708 619.927 45.7977 609.318C46.6014 594.129 48.1605 562.111 47.9677 555.553C47.7266 547.355 49.6535 527.837 57.1942 494.847C64.7348 461.856 67.5626 414.268 67.5626 377.138C67.5626 333.524 69.4478 287.478 67.5626 269.569C65.6774 251.66 67.5626 230.5 75.1033 197.932C77.9559 185.612 93.0123 129.124 93.0123 120.641C93.0123 112.157 104.323 65.028 104.323 46.1764Z"
        fill="#D6D6D6"
        stroke="#FF4646"
        stroke-width="9"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo2quiroD)"
        @mouseover="activeArea = areas.dedo2quiroD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo2quiroD.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo2quiroD.selected, hovered: activeArea == areas.dedo2quiroD }"
        class="ax-selectable"
        d="M369 508C355.8 417.6 425.833 377.667 462.5 369C457.3 379.8 459 407.5 460.5 420L467.5 521.5C469.333 531.5 473.4 552.9 475 558.5C476.6 564.1 484 609.833 487.5 632L493 678L494 689C495.667 713.333 499.2 763.5 500 769.5C501 777 499.5 781.5 497 790.5C494.5 799.5 483.5 803.5 474.5 804.5C465.5 805.5 449 803 444 798C440 794 436 774.667 434.5 765.5L433 749L417.5 676L403.5 612.5L392.5 566C389.5 554.5 383.1 529.8 381.5 523C379.5 514.5 375 516 369 508Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo4quiroD)"
        @mouseover="activeArea = areas.dedo4quiroD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo4quiroD.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo4quiroD.selected, hovered: activeArea == areas.dedo4quiroD }"
        class="ax-selectable"
        d="M150.5 502C194.9 432.8 232.667 481.833 246 515C238.8 520.6 234.667 533 233.5 538.5L230 580.5L228 632L224 661.5L220 700.5L218 719C216.5 742.833 213.4 792.6 213 801C212.5 811.5 208.5 818 205.5 822.5C199 831 184 833 178 833C163.6 830.6 155.667 821 153.5 816.5C152.333 807.333 149.9 787 149.5 779C148.3 771 147.667 755.333 147.5 748.5V709L149.5 677L152 622C153 603.167 155.1 563.4 155.5 555C156 544.5 152.5 510.5 150.5 502Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo5quiroD)"
        @mouseover="activeArea = areas.dedo5quiroD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo5quiroD.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo5quiroD.selected, hovered: activeArea == areas.dedo5quiroD }"
        class="ax-selectable"
        d="M142 499.5C132.8 433.5 86.5 450.333 64.5 467L55 516.5L51.5 543L49.5 597C48.1667 609.5 45.4 635.8 45 641C44.5 647.5 41 700 42.5 708C45 715.5 56.5 721.5 60.5 723.5C64.5 725.5 80.5 725.5 88 721.5C95.5 717.5 97 710 102 693C106 679.4 107.333 659.667 107.5 651.5V632.5L123.5 554C128.5 538.5 139.2 505.9 142 499.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo3quiroD)"
        @mouseover="activeArea = areas.dedo3quiroD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo3quiroD.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo3quiroD.selected, hovered: activeArea == areas.dedo3quiroD }"
        class="ax-selectable"
        d="M261.5 515.5C291.9 442.3 341.833 482 363 511C360.2 511.8 359.167 526.667 359 534L362.5 594.5L363.5 646.5L368.5 710.5L371 754V808C371 818.5 368.5 840 366 848.5C363.5 857 357 863.5 345 865C333 866.5 319 864 311.5 856C305.5 849.6 301 820.333 299.5 806.5L296.5 781.5C293.5 766.167 287.5 734.7 287.5 731.5V704L282.5 649.5L278.5 599.5C277 580.333 274 541.1 274 537.5C274 533 271.5 531 261.5 515.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo1quiroD)"
        @mouseover="activeArea = areas.dedo1quiroD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo1quiroD.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo1quiroD.selected, hovered: activeArea == areas.dedo1quiroD }"
        class="ax-selectable"
        d="M472 358.5C444 300.1 494.333 253.833 523 238L563.5 318L603.5 367C605 370.667 608.3 378.9 609.5 382.5C611 387 654 433.5 656.5 440.5C659 447.5 660.5 457 647 468.5C633.5 480 627 477.5 612 475.5C597 473.5 568 456 547 438.5C529 421.3 522.833 402.333 522 395C518.167 390.833 509.1 381.2 503.5 376C496.631 369.622 487.837 365.651 472.865 358.891L472 358.5Z"
      />
      <path
        d="M305.73 805.01C325.89 785.213 351.968 792.978 362.487 799.334V850.642C349.955 860.631 326.39 858.891 316.174 856.772C312.693 844.285 305.73 816.452 305.73 805.01Z"
        fill="#AAAAAA"
      />
      <path
        d="M437.08 747.443C457.24 727.646 480.985 735.414 492.075 742.164C493.836 755.184 493.836 779.534 493.836 793.074V793.075C481.305 803.064 457.739 801.323 447.523 799.204C444.042 786.718 437.08 758.885 437.08 747.443Z"
        fill="#AAAAAA"
      />
      <path
        d="M153.582 771.345C176.009 754.158 199.162 763.751 208.825 771.345C210.206 784.366 210.206 806.266 205.471 819.88C191.813 828.264 169.545 824.668 159.664 821.318C157.734 808.5 153.582 783.577 153.582 771.345Z"
        fill="#AAAAAA"
      />
      <path
        d="M47.8363 670.221C68.5683 658.666 87.643 668.832 95.2988 675.978C95.376 686.647 93.5105 704.349 88.2826 714.86C75.8341 720.214 57.0088 714.988 48.805 711.25C48.2387 700.687 46.7943 680.109 47.8363 670.221Z"
        fill="#AAAAAA"
      />
      <path
        d="M608.704 400.916C605.797 395.102 607.493 387.378 608.704 384.242L657.658 442.602C655.805 444.74 651.416 449.015 648.679 449.015C645.259 449.015 612.338 408.185 608.704 400.916Z"
        fill="#AAAAAA"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha5quiroD)"
        @mouseover="activeArea = areas.unha5quiroD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha5quiroD.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha5quiroD.selected, hovered: activeArea == areas.unha5quiroD }"
        class="ax-selectable"
        cx="50"
        cy="751"
        r="44"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha4quiroD)"
        @mouseover="activeArea = areas.unha4quiroD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha4quiroD.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha4quiroD.selected, hovered: activeArea == areas.unha4quiroD }"
        class="ax-selectable"
        cx="180"
        cy="863"
        r="44"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha3quiroD)"
        @mouseover="activeArea = areas.unha3quiroD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha3quiroD.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha3quiroD.selected, hovered: activeArea == areas.unha3quiroD }"
        class="ax-selectable"
        cx="349"
        cy="887"
        r="44"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha2quiroD)"
        @mouseover="activeArea = areas.unha2quiroD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha2quiroD.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha2quiroD.selected, hovered: activeArea == areas.unha2quiroD }"
        class="ax-selectable"
        cx="494"
        cy="825"
        r="44"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha1quiroD)"
        @mouseover="activeArea = areas.unha1quiroD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha1quiroD.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha1quiroD.selected, hovered: activeArea == areas.unha1quiroD }"
        class="ax-selectable"
        cx="682"
        cy="446"
        r="44"
        stroke="#0081F9"
        stroke-width="12"
      />
      <path
        d="M47.2485 1284.33L43.8642 1287.8C51.0018 1299.53 59.6961 1319.02 67.7091 1338.2C71.9194 1348.28 75.9676 1358.33 79.4675 1367.03C82.5627 1374.72 85.2291 1381.35 87.1996 1385.98C96.973 1408.95 97 1429.91 97 1455C97 1463.15 95.0765 1472.35 92.2734 1481.88C89.7881 1490.33 86.6557 1498.9 83.6575 1507.11C83.2777 1508.15 82.8999 1509.18 82.526 1510.21C79.2257 1519.27 76.1901 1527.86 74.6938 1534.99C73.9446 1538.57 73.5502 1541.91 73.7499 1544.85C73.9498 1547.79 74.7612 1550.54 76.6232 1552.65C78.6884 1555 79.4929 1558.88 79.085 1564.36C78.6832 1569.76 77.1518 1576.15 75.2204 1582.94C74.3803 1585.9 73.4403 1589 72.4991 1592.11C71.3395 1595.95 70.1779 1599.79 69.1985 1603.35C67.3973 1609.92 66 1616.26 66 1621.5C66 1622.38 65.9989 1623.3 65.9977 1624.27C65.9858 1634.02 65.9685 1648.14 67.0519 1661.98C67.6475 1669.59 68.5794 1677.18 70.0438 1683.95C71.5003 1690.68 73.5202 1696.79 76.3852 1701.33C80.2109 1707.4 87.3797 1714.77 96.0901 1722.57C104.852 1730.41 115.36 1738.86 126.034 1747.1C135.854 1754.69 145.766 1762.06 154.636 1768.66C164.869 1776.28 173.714 1782.86 179.426 1787.53L222.687 1892.95L222.782 1893.18L222.92 1893.39C229.139 1902.72 238.135 1910.84 246.449 1917.41C250.619 1920.71 254.657 1923.65 258.124 1926.17L258.22 1926.24C261.68 1928.75 264.489 1930.8 266.381 1932.4C268.307 1934.04 270.014 1935.69 271.66 1937.31C271.89 1937.54 272.119 1937.77 272.348 1937.99C273.74 1939.37 275.124 1940.73 276.527 1941.98C279.571 1944.69 282.886 1947 287.287 1948.16L303.764 1981.12L304.181 1981.95L305.044 1982.31C310.006 1984.36 317.945 1987 325.724 1988.27C329.613 1988.9 333.559 1989.2 337.121 1988.87C340.651 1988.55 344.068 1987.57 346.619 1985.4C349.747 1982.75 351.985 1979.04 353.582 1975.13L354.503 1992.63L354.543 1993.38L354.992 1993.99C357 1996.7 360.52 2000.78 364.647 2004.37C368.692 2007.89 373.696 2011.27 378.646 2011.97C384.218 2012.77 393.224 2012.49 401.408 2011.35C405.521 2010.78 409.524 2009.97 412.86 2008.93C416.065 2007.94 419.113 2006.59 420.85 2004.68C421.599 2003.86 422.23 2002.75 422.773 2001.6C423.332 2000.41 423.87 1999 424.385 1997.47C425.416 1994.41 426.406 1990.68 427.31 1986.79C428.158 1983.15 428.941 1979.32 429.62 1975.72C430.526 1978.72 431.516 1981.88 432.528 1984.93C433.707 1988.47 434.926 1991.9 436.087 1994.75C437.217 1997.53 438.384 2000.01 439.5 2001.5C442.063 2004.92 446.8 2008.51 452.11 2011.23C457.442 2013.96 463.717 2016 469.5 2016C474.858 2016 481.616 2015.5 487.625 2013.07C493.73 2010.6 499.146 2006.09 501.404 1998.19C503.939 1989.31 505.29 1978.92 505.95 1970.97C506.322 1971.94 506.703 1972.94 507.092 1973.96C508.115 1976.65 509.192 1979.48 510.306 1982.25C511.943 1986.31 513.706 1990.34 515.592 1993.76C517.444 1997.12 519.559 2000.17 522 2002C530.32 2008.24 544.017 2015.13 561.447 2011.96C569.797 2010.44 576.124 2008.36 580.4 2005.28C584.86 2002.06 587 1997.81 587 1992.5C587 1987.45 584.794 1981.5 582.95 1976.83C582.709 1976.22 582.474 1975.63 582.248 1975.07C581.571 1973.37 580.975 1971.88 580.537 1970.6C580.247 1969.75 580.062 1969.09 579.971 1968.61C579.924 1968.36 579.916 1968.22 579.914 1968.16C580.259 1967.04 580.406 1965.54 580.414 1963.94C580.423 1962.22 580.269 1960.19 579.902 1958.02C579.428 1955.22 578.581 1952.1 577.202 1949.12C582.437 1954.83 587.077 1959.91 588.631 1961.66C589.397 1962.52 590.466 1963.27 591.614 1963.92C592.794 1964.58 594.204 1965.22 595.774 1965.83C598.915 1967.03 602.836 1968.15 607.131 1969.01C615.69 1970.74 626.025 1971.53 634.934 1969.96C642.283 1968.67 650.232 1964.37 657.446 1959.12C664.703 1953.84 671.447 1947.43 676.402 1941.62C682.332 1934.67 682.746 1922.98 676.513 1914.52C674.985 1912.44 672.537 1909.59 669.663 1906.24C669.111 1905.6 668.544 1904.94 667.965 1904.26C664.321 1900.01 660.091 1894.99 655.916 1889.49C647.516 1878.42 639.556 1865.66 636.945 1853.48C635.304 1845.82 624.922 1823.3 599.461 1804.97C587.138 1796.1 567.4 1777.61 548.678 1759.46C541.384 1752.38 534.245 1745.36 527.792 1739.01C517.778 1729.15 509.413 1720.92 504.676 1716.64C501.008 1713.33 495.59 1706.6 488.928 1697.83C486.076 1694.08 482.982 1689.93 479.729 1685.58C475.519 1679.94 471.045 1673.94 466.486 1667.98C458.347 1657.34 449.734 1646.52 441.288 1637.23C432.871 1627.96 424.49 1620.06 416.802 1615.37C409.762 1611.07 401.871 1603.55 393.944 1594.23C386.045 1584.93 378.225 1573.97 371.306 1562.92C364.387 1551.88 358.399 1540.79 354.151 1531.26C349.845 1521.6 347.5 1513.91 347.5 1509.5C347.5 1503.83 344.877 1497.44 341.277 1490.79C338.388 1485.44 334.702 1479.64 330.85 1473.57C329.863 1472.01 328.864 1470.44 327.866 1468.86C317.961 1453.12 307.914 1435.83 305.985 1418.23C305.73 1415.9 305.436 1413.32 305.116 1410.51C303.138 1393.14 300.162 1367.01 299.32 1338.96C298.34 1306.31 300.268 1271.39 309.851 1244.85L305.566 1242.42C304.887 1243.24 304.201 1244.08 303.506 1244.93C284.417 1268.28 259.093 1299.25 220.274 1314.49C180.24 1330.19 125.297 1329.32 47.2485 1284.33Z"
        fill="#D6D6D6"
        stroke="#FF0000"
        stroke-width="5"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo5podoD)"
        @mouseover="activeArea = areas.dedo5podoD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo5podoD.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo5podoD.selected, hovered: activeArea == areas.dedo5podoD }"
        class="ax-selectable"
        d="M337 1884.5C332.6 1867.3 322.5 1857 318 1854C270 1823.2 230.333 1854.83 216.5 1874.5C216.833 1875.33 218.7 1880.1 223.5 1892.5C233.5 1909 264 1929 266 1930C268 1931 276.5 1941.5 280 1943.5C282.8 1945.1 286.5 1946.5 288 1947C292.667 1957.67 302.6 1979.4 305 1981C308 1983 331 1987.5 337 1987C343 1986.5 347 1983 351 1978C355 1973 358.5 1945 359.5 1938.5C360.3 1933.3 357.833 1930 356.5 1929C352.167 1923 343.2 1910.2 342 1907C340.5 1903 340 1897.5 337 1884.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo2podoD)"
        @mouseover="activeArea = areas.dedo2podoD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo2podoD.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo2podoD.selected, hovered: activeArea == areas.dedo2podoD }"
        class="ax-selectable"
        d="M549 1894L541.5 1844.5C501.9 1825.3 480.333 1853.83 474.5 1870.5C477.167 1875.67 482.8 1886.5 484 1888.5C485.5 1891 497 1918.5 497 1919.5C497 1920.5 499 1930.5 499 1936C499 1941.5 505.5 1964.5 506.5 1968C507.5 1971.5 516.5 1992 520.5 1998C530 2007.5 543.5 2010.5 553 2011C568 2010 580 2003.5 584 1999.5C587.2 1996.3 585.333 1988.17 584 1984.5C582.333 1980.33 578.8 1971.3 578 1968.5C578.5 1964 578.5 1970 578 1960C577.6 1952 572.5 1944.33 570 1941.5L566.5 1936C565.333 1931 562.6 1919.3 561 1912.5C559.4 1905.7 552.333 1897.33 549 1894Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo4podoD)"
        @mouseover="activeArea = areas.dedo4podoD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo4podoD.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo4podoD.selected, hovered: activeArea == areas.dedo4podoD }"
        class="ax-selectable"
        d="M423 1920C421.4 1907.6 409.667 1883.5 404 1873C377.2 1815.4 336.167 1834 319 1850.5C321.5 1852 323 1853.5 326.5 1857.5C331 1861.5 336.5 1876 338 1879C339.5 1882 343.5 1895 343.5 1899C343.5 1902.2 344.5 1904 345 1904.5C349.667 1912.17 359.4 1928.3 361 1931.5C363 1935.5 362.5 1945 362 1948C361.5 1951 356 1972.5 355 1975.5C354 1978.5 355 1990.5 356 1993C357 1995.5 370 2006.5 372 2007.5C374 2008.5 378 2012.5 395 2010.5C412 2008.5 416 2007 420 2003C424 1999 428 1978.5 428 1974.5C426.5 1970.5 423 1936.5 423 1932.5C423 1928.5 424 1925.5 423 1920Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo3podoD)"
        @mouseover="activeArea = areas.dedo3podoD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo3podoD.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo3podoD.selected, hovered: activeArea == areas.dedo3podoD }"
        class="ax-selectable"
        d="M493 1917C490.2 1905 477.5 1882.67 471.5 1873C445.5 1835.4 417.333 1856.33 406.5 1871.5C407 1872.83 409.4 1878.2 415 1889C420.6 1899.8 425.333 1917.5 427 1925C425.5 1931.5 426 1933.5 427 1939.5C427 1944.3 429.667 1965.5 431 1975.5C433.167 1982 438 1995.9 440 1999.5C442.5 2004 451 2009 456.5 2011.5C479 2017.5 488.5 2011.5 497 2005.5C504 1998 505 1972 505 1967.5C501.5 1961.5 495 1931.5 495 1930C495 1928.5 495.5 1925.5 493 1917Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo1podoD)"
        @mouseover="activeArea = areas.dedo1podoD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo1podoD.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo1podoD.selected, hovered: activeArea == areas.dedo1podoD }"
        class="ax-selectable"
        d="M624 1830.5C616.8 1818.9 601.333 1807.67 594.5 1803.5C558.1 1797.5 546 1827.67 544.5 1843.5C545 1845.67 546.1 1851.6 546.5 1858C546.9 1864.4 550 1883.33 551.5 1892C552.833 1893 556.4 1896.8 560 1904C564.5 1913 567 1930.5 568 1936C571 1940.5 582 1953 593 1962.5C615 1972.5 631.5 1969 640 1966.5C661.5 1957 670.5 1946 678.5 1936C682.9 1926.4 676.667 1916.67 673 1913C670.167 1909.33 663.5 1900.9 659.5 1896.5C654.5 1891 641.5 1870 640 1867.5C638.8 1865.5 636.167 1855.67 635 1851C634.333 1849 631.2 1842.1 624 1830.5Z"
      />
      <path
        d="M601.033 1910.05C604.746 1898.38 632.236 1893.15 645.517 1892C656.039 1899.99 665.89 1918.63 669.5 1926.95L622.695 1950C613.927 1941.55 597.319 1921.73 601.033 1910.05Z"
        fill="#AAAAAA"
      />
      <path
        d="M547 1997.85C564 1985.85 573.667 1987.5 582 1988C579.333 1982.17 572.5 1969.1 566.5 1963.5C556.728 1959.09 548.384 1961.85 541.86 1968.11C538.419 1971.42 537.917 1976.5 538.507 1981.23C539.396 1988.35 537.868 1989.35 547 1997.85Z"
        fill="#AAAAAA"
      />
      <path
        d="M456.5 1999.5C476.516 1993.81 487.303 1992.27 495 1995.5C494.416 1989.11 493.306 1980.77 489.5 1973.5C481.654 1966.02 470.7 1965.94 461.555 1969.82C457.164 1971.68 454.734 1976.26 454.613 1981.03C454.414 1988.81 455.308 1990.36 456.5 1999.5Z"
        fill="#AAAAAA"
      />
      <path
        d="M376.677 1993.75C397.169 1990.13 408.056 1989.69 415.384 1993.69C415.454 1987.28 415.199 1978.87 412.153 1971.25C405.11 1963 394.221 1961.81 384.729 1964.74C380.17 1966.15 377.287 1970.45 376.68 1975.18C375.691 1982.9 376.422 1984.54 376.677 1993.75Z"
        fill="#AAAAAA"
      />
      <path
        d="M318.581 1967.43C333.668 1968.11 341.447 1969.53 346.004 1973.52C347.069 1968.99 348.221 1962.99 347.27 1957.11C343.939 1950.82 337.465 1948.12 330.941 1948.09C326.171 1948.06 322.307 1951.69 320.856 1956.23C319.642 1960.03 319.686 1961.76 318.581 1967.43Z"
        fill="#AAAAAA"
      />
      <path
        d="M568 1937C563.783 1929.75 568 1914.5 550 1893C545.265 1873.12 544.581 1849.23 543 1843.5M506.5 1968.5C503.167 1958.67 496.5 1936.5 496.5 1926.5C496.5 1914 478.5 1880 472.5 1871.5M430 1977.5C427.833 1964.67 423.8 1936.5 425 1926.5C426.2 1916.5 412.167 1885.67 405 1871.5M353 1977.5C357 1965.83 363.8 1940.1 359 1930.5C353 1918.5 341.5 1905 341.5 1898.5C341.5 1892 331 1858 317.5 1852M82 1564C87.6667 1573.33 100 1592.4 104 1594C109 1596 140 1563.5 157.5 1560M314.5 1515C300 1509.33 260.1 1503.6 216.5 1526"
        stroke="#FF0000"
        stroke-width="5"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha1podoD)"
        @mouseover="activeArea = areas.unha1podoD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha1podoD.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha1podoD.selected, hovered: activeArea == areas.unha1podoD }"
        class="ax-selectable"
        cx="679"
        cy="1956"
        r="44"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha2podoD)"
        @mouseover="activeArea = areas.unha2podoD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha2podoD.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha2podoD.selected, hovered: activeArea == areas.unha2podoD }"
        class="ax-selectable"
        cx="578"
        cy="2009"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha3podoD)"
        @mouseover="activeArea = areas.unha3podoD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha3podoD.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha3podoD.selected, hovered: activeArea == areas.unha3podoD }"
        class="ax-selectable"
        cx="474"
        cy="2021"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha4podoD)"
        @mouseover="activeArea = areas.unha4podoD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha4podoD.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha4podoD.selected, hovered: activeArea == areas.unha4podoD }"
        class="ax-selectable"
        cx="390"
        cy="2015"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha5podoD)"
        @mouseover="activeArea = areas.unha5podoD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha5podoD.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha5podoD.selected, hovered: activeArea == areas.unha5podoD }"
        class="ax-selectable"
        cx="306"
        cy="1991"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <path
        d="M1622.27 1284.33L1625.66 1287.8C1618.52 1299.53 1609.83 1319.02 1601.81 1338.2C1597.6 1348.28 1593.55 1358.33 1590.05 1367.03C1586.96 1374.72 1584.29 1381.35 1582.32 1385.98C1572.55 1408.95 1572.52 1429.91 1572.52 1455C1572.52 1463.15 1574.44 1472.35 1577.25 1481.88C1579.73 1490.33 1582.87 1498.9 1585.86 1507.11C1586.24 1508.15 1586.62 1509.18 1587 1510.21C1590.3 1519.27 1593.33 1527.86 1594.83 1534.99C1595.58 1538.57 1595.97 1541.91 1595.77 1544.85C1595.57 1547.79 1594.76 1550.54 1592.9 1552.65C1590.83 1555 1590.03 1558.88 1590.44 1564.36C1590.84 1569.76 1592.37 1576.15 1594.3 1582.94C1595.14 1585.9 1596.08 1589 1597.02 1592.11C1598.18 1595.95 1599.34 1599.79 1600.32 1603.35C1602.12 1609.92 1603.52 1616.26 1603.52 1621.5C1603.52 1622.38 1603.52 1623.3 1603.52 1624.27C1603.54 1634.02 1603.55 1648.14 1602.47 1661.98C1601.87 1669.59 1600.94 1677.18 1599.48 1683.95C1598.02 1690.68 1596 1696.79 1593.14 1701.33C1589.31 1707.4 1582.14 1714.77 1573.43 1722.57C1564.67 1730.41 1554.16 1738.86 1543.49 1747.1C1533.67 1754.69 1523.75 1762.06 1514.89 1768.66C1504.65 1776.28 1495.81 1782.86 1490.1 1787.53L1446.83 1892.95L1446.74 1893.18L1446.6 1893.39C1440.38 1902.72 1431.39 1910.84 1423.07 1917.41C1418.9 1920.71 1414.86 1923.65 1411.4 1926.17L1411.3 1926.24C1407.84 1928.75 1405.03 1930.8 1403.14 1932.4C1401.21 1934.04 1399.51 1935.69 1397.86 1937.31C1397.63 1937.54 1397.4 1937.77 1397.17 1937.99C1395.78 1939.37 1394.4 1940.73 1392.99 1941.98C1389.95 1944.69 1386.63 1947 1382.23 1948.16L1365.76 1981.12L1365.34 1981.95L1364.48 1982.31C1359.52 1984.36 1351.58 1987 1343.8 1988.27C1339.91 1988.9 1335.96 1989.2 1332.4 1988.87C1328.87 1988.55 1325.45 1987.57 1322.9 1985.4C1319.77 1982.75 1317.54 1979.04 1315.94 1975.13L1315.02 1992.63L1314.98 1993.38L1314.53 1993.99C1312.52 1996.7 1309 2000.78 1304.87 2004.37C1300.83 2007.89 1295.83 2011.27 1290.87 2011.97C1285.3 2012.77 1276.3 2012.49 1268.11 2011.35C1264 2010.78 1260 2009.97 1256.66 2008.93C1253.46 2007.94 1250.41 2006.59 1248.67 2004.68C1247.92 2003.86 1247.29 2002.75 1246.75 2001.6C1246.19 2000.41 1245.65 1999 1245.14 1997.47C1244.11 1994.41 1243.12 1990.68 1242.21 1986.79C1241.36 1983.15 1240.58 1979.32 1239.9 1975.72C1239 1978.72 1238.01 1981.88 1236.99 1984.93C1235.81 1988.47 1234.6 1991.9 1233.43 1994.75C1232.3 1997.53 1231.14 2000.01 1230.02 2001.5C1227.46 2004.92 1222.72 2008.51 1217.41 2011.23C1212.08 2013.96 1205.8 2016 1200.02 2016C1194.66 2016 1187.91 2015.5 1181.9 2013.07C1175.79 2010.6 1170.38 2006.09 1168.12 1998.19C1165.58 1989.31 1164.23 1978.92 1163.57 1970.97C1163.2 1971.94 1162.82 1972.94 1162.43 1973.96C1161.41 1976.65 1160.33 1979.48 1159.21 1982.25C1157.58 1986.31 1155.81 1990.34 1153.93 1993.76C1152.08 1997.12 1149.96 2000.17 1147.52 2002C1139.2 2008.24 1125.5 2015.13 1108.07 2011.96C1099.72 2010.44 1093.4 2008.36 1089.12 2005.28C1084.66 2002.06 1082.52 1997.81 1082.52 1992.5C1082.52 1987.45 1084.73 1981.5 1086.57 1976.83C1086.81 1976.22 1087.05 1975.63 1087.27 1975.07C1087.95 1973.37 1088.55 1971.88 1088.98 1970.6C1089.27 1969.75 1089.46 1969.09 1089.55 1968.61C1089.6 1968.36 1089.61 1968.22 1089.61 1968.16C1089.26 1967.04 1089.12 1965.54 1089.11 1963.94C1089.1 1962.22 1089.25 1960.19 1089.62 1958.02C1090.09 1955.22 1090.94 1952.1 1092.32 1949.12C1087.08 1954.83 1082.44 1959.91 1080.89 1961.66C1080.12 1962.52 1079.06 1963.27 1077.91 1963.92C1076.73 1964.58 1075.32 1965.22 1073.75 1965.83C1070.61 1967.03 1066.69 1968.15 1062.39 1969.01C1053.83 1970.74 1043.5 1971.53 1034.59 1969.96C1027.24 1968.67 1019.29 1964.37 1012.08 1959.12C1004.82 1953.84 998.074 1947.43 993.119 1941.62C987.189 1934.67 986.775 1922.98 993.009 1914.52C994.536 1912.44 996.984 1909.59 999.859 1906.24C1000.41 1905.6 1000.98 1904.94 1001.56 1904.26C1005.2 1900.01 1009.43 1894.99 1013.61 1889.49C1022 1878.42 1029.97 1865.66 1032.58 1853.48C1034.22 1845.82 1044.6 1823.3 1070.06 1804.97C1082.38 1796.1 1102.12 1777.61 1120.84 1759.46C1128.14 1752.38 1135.28 1745.36 1141.73 1739.01C1151.74 1729.15 1160.11 1720.92 1164.85 1716.64C1168.51 1713.33 1173.93 1706.6 1180.59 1697.83C1183.44 1694.08 1186.54 1689.93 1189.79 1685.58C1194 1679.94 1198.48 1673.94 1203.04 1667.98C1211.17 1657.34 1219.79 1646.52 1228.23 1637.23C1236.65 1627.96 1245.03 1620.06 1252.72 1615.37C1259.76 1611.07 1267.65 1603.55 1275.58 1594.23C1283.48 1584.93 1291.3 1573.97 1298.22 1562.92C1305.13 1551.88 1311.12 1540.79 1315.37 1531.26C1319.68 1521.6 1322.02 1513.91 1322.02 1509.5C1322.02 1503.83 1324.64 1497.44 1328.24 1490.79C1331.13 1485.44 1334.82 1479.64 1338.67 1473.57C1339.66 1472.01 1340.66 1470.44 1341.66 1468.86C1351.56 1453.12 1361.61 1435.83 1363.54 1418.23C1363.79 1415.9 1364.08 1413.32 1364.41 1410.51C1366.38 1393.14 1369.36 1367.01 1370.2 1338.96C1371.18 1306.31 1369.25 1271.39 1359.67 1244.85L1363.96 1242.42C1364.63 1243.24 1365.32 1244.08 1366.02 1244.93C1385.1 1268.28 1410.43 1299.25 1449.25 1314.49C1489.28 1330.19 1544.22 1329.32 1622.27 1284.33Z"
        fill="#D6D6D6"
        stroke="#FF0000"
        stroke-width="5"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo5podoE)"
        @mouseover="activeArea = areas.dedo5podoE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo5podoE.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo5podoE.selected, hovered: activeArea == areas.dedo5podoE }"
        class="ax-selectable"
        d="M1333.01 1884.78C1337.41 1867.58 1347.51 1857.28 1352.01 1854.28C1400.01 1823.48 1439.68 1855.11 1453.51 1874.78C1453.18 1875.61 1451.31 1880.38 1446.51 1892.78C1436.51 1909.28 1406.01 1929.28 1404.01 1930.28C1402.01 1931.28 1393.51 1941.78 1390.01 1943.78C1387.21 1945.38 1383.51 1946.78 1382.01 1947.28C1377.35 1957.94 1367.41 1979.68 1365.01 1981.28C1362.01 1983.28 1339.01 1987.78 1333.01 1987.28C1327.01 1986.78 1323.01 1983.28 1319.01 1978.28C1315.01 1973.28 1311.51 1945.28 1310.51 1938.78C1309.71 1933.58 1312.18 1930.28 1313.51 1929.28C1317.85 1923.28 1326.81 1910.48 1328.01 1907.28C1329.51 1903.28 1330.01 1897.78 1333.01 1884.78Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo2podoE)"
        @mouseover="activeArea = areas.dedo2podoE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo2podoE.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo2podoE.selected, hovered: activeArea == areas.dedo2podoE }"
        class="ax-selectable"
        d="M1121.01 1894.28L1128.51 1844.78C1168.11 1825.58 1189.68 1854.11 1195.51 1870.78C1192.85 1875.94 1187.21 1886.78 1186.01 1888.78C1184.51 1891.28 1173.01 1918.78 1173.01 1919.78C1173.01 1920.78 1171.01 1930.78 1171.01 1936.28C1171.01 1941.78 1164.51 1964.78 1163.51 1968.28C1162.51 1971.78 1153.51 1992.28 1149.51 1998.28C1140.01 2007.78 1126.51 2010.78 1117.01 2011.28C1102.01 2010.28 1090.01 2003.78 1086.01 1999.78C1082.81 1996.58 1084.68 1988.44 1086.01 1984.78C1087.68 1980.61 1091.21 1971.58 1092.01 1968.78C1091.51 1964.28 1091.51 1970.28 1092.01 1960.28C1092.41 1952.28 1097.51 1944.61 1100.01 1941.78L1103.51 1936.28C1104.68 1931.28 1107.41 1919.58 1109.01 1912.78C1110.61 1905.98 1117.68 1897.61 1121.01 1894.28Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo4podoE)"
        @mouseover="activeArea = areas.dedo4podoE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo4podoE.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo4podoE.selected, hovered: activeArea == areas.dedo4podoE }"
        class="ax-selectable"
        d="M1247.01 1920.28C1248.61 1907.88 1260.35 1883.78 1266.01 1873.28C1292.81 1815.68 1333.85 1834.28 1351.01 1850.78C1348.51 1852.28 1347.01 1853.78 1343.51 1857.78C1339.01 1861.78 1333.51 1876.28 1332.01 1879.28C1330.51 1882.28 1326.51 1895.28 1326.51 1899.28C1326.51 1902.48 1325.51 1904.28 1325.01 1904.78C1320.35 1912.45 1310.61 1928.58 1309.01 1931.78C1307.01 1935.78 1307.51 1945.28 1308.01 1948.28C1308.51 1951.28 1314.01 1972.78 1315.01 1975.78C1316.01 1978.78 1315.01 1990.78 1314.01 1993.28C1313.01 1995.78 1300.01 2006.78 1298.01 2007.78C1296.01 2008.78 1292.01 2012.78 1275.01 2010.78C1258.01 2008.78 1254.01 2007.28 1250.01 2003.28C1246.01 1999.28 1242.01 1978.78 1242.01 1974.78C1243.51 1970.78 1247.01 1936.78 1247.01 1932.78C1247.01 1928.78 1246.01 1925.78 1247.01 1920.28Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo3podoE)"
        @mouseover="activeArea = areas.dedo3podoE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo3podoE.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo3podoE.selected, hovered: activeArea == areas.dedo3podoE }"
        class="ax-selectable"
        d="M1177.01 1917.28C1179.81 1905.28 1192.51 1882.95 1198.51 1873.28C1224.51 1835.68 1252.68 1856.61 1263.51 1871.78C1263.01 1873.11 1260.61 1878.48 1255.01 1889.28C1249.41 1900.08 1244.68 1917.78 1243.01 1925.28C1244.51 1931.78 1244.01 1933.78 1243.01 1939.78C1243.01 1944.58 1240.35 1965.78 1239.01 1975.78C1236.85 1982.28 1232.01 1996.18 1230.01 1999.78C1227.51 2004.28 1219.01 2009.28 1213.51 2011.78C1191.01 2017.78 1181.51 2011.78 1173.01 2005.78C1166.01 1998.28 1165.01 1972.28 1165.01 1967.78C1168.51 1961.78 1175.01 1931.78 1175.01 1930.28C1175.01 1928.78 1174.51 1925.78 1177.01 1917.28Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.dedo1podoE)"
        @mouseover="activeArea = areas.dedo1podoE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.dedo1podoE.selected ? activeColor : inactiveColor"
        :class="{ active: data.dedo1podoE.selected, hovered: activeArea == areas.dedo1podoE }"
        class="ax-selectable"
        d="M1046.01 1830.78C1053.21 1819.18 1068.68 1807.94 1075.51 1803.78C1111.91 1797.78 1124.01 1827.94 1125.51 1843.78C1125.01 1845.94 1123.91 1851.88 1123.51 1858.28C1123.11 1864.68 1120.01 1883.61 1118.51 1892.28C1117.18 1893.28 1113.61 1897.08 1110.01 1904.28C1105.51 1913.28 1103.01 1930.78 1102.01 1936.28C1099.01 1940.78 1088.01 1953.28 1077.01 1962.78C1055.01 1972.78 1038.51 1969.28 1030.01 1966.78C1008.51 1957.28 999.513 1946.28 991.513 1936.28C987.113 1926.68 993.347 1916.94 997.013 1913.28C999.847 1909.61 1006.51 1901.18 1010.51 1896.78C1015.51 1891.28 1028.51 1870.28 1030.01 1867.78C1031.21 1865.78 1033.85 1855.94 1035.01 1851.28C1035.68 1849.28 1038.81 1842.38 1046.01 1830.78Z"
      />
      <path
        d="M1068.49 1910.05C1064.77 1898.38 1037.28 1893.15 1024 1892C1013.48 1899.99 1003.63 1918.63 1000.02 1926.95L1046.83 1950C1055.59 1941.55 1072.2 1921.73 1068.49 1910.05Z"
        fill="#AAAAAA"
      />
      <path
        d="M1122.52 1997.85C1105.52 1985.85 1095.85 1987.5 1087.52 1988C1090.19 1982.17 1097.02 1969.1 1103.02 1963.5C1112.79 1959.09 1121.14 1961.85 1127.66 1968.11C1131.1 1971.42 1131.6 1976.5 1131.01 1981.23C1130.13 1988.35 1131.65 1989.35 1122.52 1997.85Z"
        fill="#AAAAAA"
      />
      <path
        d="M1213.02 1999.5C1193.01 1993.81 1182.22 1992.27 1174.52 1995.5C1175.11 1989.11 1176.21 1980.77 1180.02 1973.5C1187.87 1966.02 1198.82 1965.94 1207.97 1969.82C1212.36 1971.68 1214.79 1976.26 1214.91 1981.03C1215.11 1988.81 1214.21 1990.36 1213.02 1999.5Z"
        fill="#AAAAAA"
      />
      <path
        d="M1292.84 1993.75C1272.35 1990.13 1261.47 1989.69 1254.14 1993.69C1254.07 1987.28 1254.32 1978.87 1257.37 1971.25C1264.41 1963 1275.3 1961.81 1284.79 1964.74C1289.35 1966.15 1292.23 1970.45 1292.84 1975.18C1293.83 1982.9 1293.1 1984.54 1292.84 1993.75Z"
        fill="#AAAAAA"
      />
      <path
        d="M1350.94 1967.43C1335.85 1968.11 1328.07 1969.53 1323.52 1973.52C1322.45 1968.99 1321.3 1962.99 1322.25 1957.11C1325.58 1950.82 1332.06 1948.12 1338.58 1948.09C1343.35 1948.06 1347.21 1951.69 1348.67 1956.23C1349.88 1960.03 1349.83 1961.76 1350.94 1967.43Z"
        fill="#AAAAAA"
      />
      <path
        d="M1101.52 1937C1105.74 1929.75 1101.52 1914.5 1119.52 1893C1124.26 1873.12 1124.94 1849.23 1126.52 1843.5M1163.02 1968.5C1166.35 1958.67 1173.02 1936.5 1173.02 1926.5C1173.02 1914 1191.02 1880 1197.02 1871.5M1239.52 1977.5C1241.69 1964.67 1245.72 1936.5 1244.52 1926.5C1243.32 1916.5 1257.35 1885.67 1264.52 1871.5M1316.52 1977.5C1312.52 1965.83 1305.72 1940.1 1310.52 1930.5C1316.52 1918.5 1328.02 1905 1328.02 1898.5C1328.02 1892 1338.52 1858 1352.02 1852M1587.52 1564C1581.85 1573.33 1569.52 1592.4 1565.52 1594C1560.52 1596 1529.52 1563.5 1512.02 1560M1355.02 1515C1369.52 1509.33 1409.42 1503.6 1453.02 1526"
        stroke="#FF0000"
        stroke-width="5"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha1podoE)"
        @mouseover="activeArea = areas.unha1podoE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha1podoE.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha1podoE.selected, hovered: activeArea == areas.unha1podoE }"
        class="ax-selectable"
        r="44"
        transform="matrix(-1 0 0 1 989 1956)"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha2podoE)"
        @mouseover="activeArea = areas.unha2podoE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha2podoE.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha2podoE.selected, hovered: activeArea == areas.unha2podoE }"
        class="ax-selectable"
        r="29"
        transform="matrix(-1 0 0 1 1090 2009)"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha3podoE)"
        @mouseover="activeArea = areas.unha3podoE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha3podoE.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha3podoE.selected, hovered: activeArea == areas.unha3podoE }"
        class="ax-selectable"
        r="29"
        transform="matrix(-1 0 0 1 1194 2021)"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha4podoE)"
        @mouseover="activeArea = areas.unha4podoE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha4podoE.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha4podoE.selected, hovered: activeArea == areas.unha4podoE }"
        class="ax-selectable"
        r="29"
        transform="matrix(-1 0 0 1 1278 2015)"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.unha5podoE)"
        @mouseover="activeArea = areas.unha5podoE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.unha5podoE.selected ? activeColor : inactiveColor"
        :class="{ active: data.unha5podoE.selected, hovered: activeArea == areas.unha5podoE }"
        class="ax-selectable"
        r="29"
        transform="matrix(-1 0 0 1 1362 1991)"
        stroke="#0081F9"
        stroke-width="12"
      />
    </svg>

    <v-tooltip :value="!!activeArea" :position-x="tooltipPositionX" :position-y="tooltipPositionY" top>
      {{ tooltiplabel }}
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    height: String,
    width: String,
    value: Object,
  },
  computed: {
    tooltiplabel() {
      return this.activeArea?.label || ''
    },
  },
  methods: {
    buildEmptyDataObject() {
      return Object.values(this.areas).reduce(
        (acc, option) => ({
          ...acc,
          [option.key]: { selected: false, dorSelected: false, inchSelected: false, label: option.label },
        }),
        {},
      )
    },
    setPosition(e) {
      this.tooltipPositionX = e.clientX
      this.tooltipPositionY = e.clientY
    },
    eventClickOnGerericAreas(clickedArea) {
      this.data[clickedArea.key].selected = !this.data[clickedArea.key].selected
      this.$emit('input', this.data)
    },
  },
  mounted() {
    this.data = { ...this.buildEmptyDataObject(), ...this.value }
    this.isMounted = true
  },
  data() {
    return {
      isMounted: false,
      activeColor: '#ff0000',
      inactiveColor: '#fff',
      data: null,
      tooltipPositionX: null,
      tooltipPositionY: null,
      activeArea: null,
      areas: {
        maiorD: {
          key: 'maiorD',
          label: 'Trocânter maior D',
        },
        maiorE: {
          key: 'maiorE',
          label: 'Trocânter maior E',
        },
        meta1D: {
          key: 'meta1D',
          label: '1ª Metacarpofalangeana D',
        },
        meta1E: {
          key: 'meta1E',
          label: '1ª Metacarpofalangeana E',
        },
        meta2D: {
          key: 'meta2D',
          label: '2ª Metacarpofalangeana D',
        },
        meta2E: {
          key: 'meta2E',
          label: '2ª Metacarpofalangeana E',
        },
        meta3D: {
          key: 'meta3D',
          label: '3ª Metacarpofalangeana D',
        },
        meta3E: {
          key: 'meta3E',
          label: '3ª Metacarpofalangeana E',
        },
        meta4D: {
          key: 'meta4D',
          label: '4ª Metacarpofalangeana D',
        },
        meta4E: {
          key: 'meta4E',
          label: '4ª Metacarpofalangeana E',
        },
        meta5D: {
          key: 'meta5D',
          label: '5ª Metacarpofalangeana D',
        },
        meta5E: {
          key: 'meta5E',
          label: '5ª Metacarpofalangeana E',
        },
        ombroD: {
          key: 'ombroD',
          label: 'Ombro D',
        },
        ombroE: {
          key: 'ombroE',
          label: 'Ombro E',
        },
        punhoD: {
          key: 'punhoD',
          label: 'Punho D',
        },
        punhoE: {
          key: 'punhoE',
          label: 'Punho E',
        },
        tarsoD: {
          key: 'tarsoD',
          label: 'Tarso D',
        },
        tarsoE: {
          key: 'tarsoE',
          label: 'Tarso E',
        },
        tibiaD: {
          key: 'tibiaD',
          label: 'Tíbia D',
        },
        tibiaE: {
          key: 'tibiaE',
          label: 'Tíbia E',
        },
        cristaD: {
          key: 'cristaD',
          label: 'Crista ilíaca D',
        },
        cristaE: {
          key: 'cristaE',
          label: 'Crista ilíaca E',
        },
        joelhoD: {
          key: 'joelhoD',
          label: 'Joelho D',
        },
        joelhoE: {
          key: 'joelhoE',
          label: 'Joelho E',
        },
        medialD: {
          key: 'medialD',
          label: 'Epicôndilo medial D',
        },
        medialE: {
          key: 'medialE',
          label: 'Epicôndilo medial E',
        },
        aquilesD: {
          key: 'aquilesD',
          label: 'Tendão de Aquiles D',
        },
        aquilesE: {
          key: 'aquilesE',
          label: 'Tendão de Aquiles E',
        },
        lateralD: {
          key: 'lateralD',
          label: 'Epicôndilo lateral D',
        },
        lateralE: {
          key: 'lateralE',
          label: 'Epicôndilo lateral E',
        },
        patelarD: {
          key: 'patelarD',
          label: 'Ligamento patelar D',
        },
        patelarE: {
          key: 'patelarE',
          label: 'Ligamento patelar E',
        },
        plantarD: {
          key: 'plantarD',
          label: 'Fáscia plantar  D',
        },
        plantarE: {
          key: 'plantarE',
          label: 'Fáscia plantar  D',
        },
        quadrilD: {
          key: 'quadrilD',
          label: 'Quadril D',
          hideInch: true,
        },
        quadrilE: {
          key: 'quadrilE',
          label: 'Quadril E',
          hideInch: true,
        },
        cotoveloD: {
          key: 'cotoveloD',
          label: 'Cotovelo D',
        },
        cotoveloE: {
          key: 'cotoveloE',
          label: 'Cotovelo E',
        },
        metatar1D: {
          key: 'metatar1D',
          label: '1ª Metatarsofalangeana D',
        },
        metatar1E: {
          key: 'metatar1E',
          label: '1ª Metatarsofalangeana E',
        },
        metatar2D: {
          key: 'metatar2D',
          label: '2ª Metatarsofalangeana D',
        },
        metatar2E: {
          key: 'metatar2E',
          label: '2ª Metatarsofalangeana E',
        },
        metatar3D: {
          key: 'metatar3D',
          label: '3ª Metatarsofalangeana D',
        },
        metatar3E: {
          key: 'metatar3E',
          label: '3ª Metatarsofalangeana E',
        },
        metatar4D: {
          key: 'metatar4D',
          label: '4ª Metatarsofalangeana D',
        },
        metatar4E: {
          key: 'metatar4E',
          label: '4ª Metatarsofalangeana E',
        },
        metatar5D: {
          key: 'metatar5D',
          label: '5ª Metatarsofalangeana D',
        },
        metatar5E: {
          key: 'metatar5E',
          label: '5ª Metatarsofalangeana E',
        },
        dedo1podoD: {
          key: 'dedo1podoD',
          label: 'Dedo - 1º pododáctilo D',
        },
        dedo1podoE: {
          key: 'dedo1podoE',
          label: 'Dedo - 1º pododáctilo E',
        },
        dedo2podoD: {
          key: 'dedo2podoD',
          label: 'Dedo - 2º pododáctilo D',
        },
        dedo2podoE: {
          key: 'dedo2podoE',
          label: 'Dedo - 2º pododáctilo E',
        },
        dedo3podoD: {
          key: 'dedo3podoD',
          label: 'Dedo - 3º pododáctilo D',
        },
        dedo3podoE: {
          key: 'dedo3podoE',
          label: 'Dedo - 3º pododáctilo E',
        },
        dedo4podoD: {
          key: 'dedo4podoD',
          label: 'Dedo - 4º pododáctilo D',
        },
        dedo4podoE: {
          key: 'dedo4podoE',
          label: 'Dedo - 4º pododáctilo E',
        },
        dedo5podoD: {
          key: 'dedo5podoD',
          label: 'Dedo - 5º pododáctilo D',
        },
        dedo5podoE: {
          key: 'dedo5podoE',
          label: 'Dedo - 5º pododáctilo E',
        },
        espinhoso5: {
          key: 'espinhoso5',
          label: '5º processo espinhoso lombar',
        },
        proximal1D: {
          key: 'proximal1D',
          label: '1ª Interfalangeana proximal pé D',
        },
        proximal1E: {
          key: 'proximal1E',
          label: '1ª Interfalangeana proximal pé E',
        },
        proximal2D: {
          key: 'proximal2D',
          label: '2ª Interfalangeana proximal pé D',
        },
        proximal2E: {
          key: 'proximal2E',
          label: '2ª Interfalangeana proximal pé E',
        },
        proximal3D: {
          key: 'proximal3D',
          label: '3ª Interfalangeana proximal pé D',
        },
        proximal3E: {
          key: 'proximal3E',
          label: '3ª Interfalangeana proximal pé E',
        },
        proximal4D: {
          key: 'proximal4D',
          label: '4ª Interfalangeana proximal pé D',
        },
        proximal4E: {
          key: 'proximal4E',
          label: '4ª Interfalangeana proximal pé E',
        },
        proximal5D: {
          key: 'proximal5D',
          label: '5ª Interfalangeana proximal pé D',
        },
        proximal5E: {
          key: 'proximal5E',
          label: '5ª Interfalangeana proximal pé E',
        },
        tornozeloD: {
          key: 'tornozeloD',
          label: 'Tornozelo D',
        },
        tornozeloE: {
          key: 'tornozeloE',
          label: 'Tornozelo E',
        },
        unha1podoD: {
          key: 'unha1podoD',
          label: 'Unha - 1º pododáctilo D',
        },
        unha1podoE: {
          key: 'unha1podoE',
          label: 'Unha - 1º pododáctilo E',
        },
        unha2podoD: {
          key: 'unha2podoD',
          label: 'Unha - 2º pododáctilo D',
        },
        unha2podoE: {
          key: 'unha2podoE',
          label: 'Unha - 2º pododáctilo E',
        },
        unha3podoD: {
          key: 'unha3podoD',
          label: 'Unha - 3º pododáctilo D',
        },
        unha3podoE: {
          key: 'unha3podoE',
          label: 'Unha - 3º pododáctilo E',
        },
        unha4podoD: {
          key: 'unha4podoD',
          label: 'Unha - 4º pododáctilo D',
        },
        unha4podoE: {
          key: 'unha4podoE',
          label: 'Unha - 4º pododáctilo E',
        },
        unha5podoD: {
          key: 'unha5podoD',
          label: 'Unha - 5º pododáctilo D',
        },
        unha5podoE: {
          key: 'unha5podoE',
          label: 'Unha - 5º pododáctilo E',
        },
        dedo1quiroD: {
          key: 'dedo1quiroD',
          label: 'Dedo - 1º quirodáctilo D',
        },
        dedo1quiroE: {
          key: 'dedo1quiroE',
          label: 'Dedo - 1º quirodáctilo E',
        },
        dedo2quiroD: {
          key: 'dedo2quiroD',
          label: 'Dedo - 2º quirodáctilo D',
        },
        dedo2quiroE: {
          key: 'dedo2quiroE',
          label: 'Dedo - 2º quirodáctilo E',
        },
        dedo3quiroD: {
          key: 'dedo3quiroD',
          label: 'Dedo - 3º quirodáctilo D',
        },
        dedo3quiroE: {
          key: 'dedo3quiroE',
          label: 'Dedo - 3º quirodáctilo E',
        },
        dedo4quiroD: {
          key: 'dedo4quiroD',
          label: 'Dedo - 4º quirodáctilo D',
        },
        dedo4quiroE: {
          key: 'dedo4quiroE',
          label: 'Dedo - 4º quirodáctilo E',
        },
        dedo5quiroD: {
          key: 'dedo5quiroD',
          label: 'Dedo - 5º quirodáctilo D',
        },
        dedo5quiroE: {
          key: 'dedo5quiroE',
          label: 'Dedo - 5º quirodáctilo E',
        },
        distalMao2D: {
          key: 'distalMao2D',
          label: '2ª Interfalangeana distal mão D',
        },
        distalMao2E: {
          key: 'distalMao2E',
          label: '2ª Interfalangeana distal mão E',
        },
        distalMao3D: {
          key: 'distalMao3D',
          label: '3ª Interfalangeana distal mão D',
        },
        distalMao3E: {
          key: 'distalMao3E',
          label: '3ª Interfalangeana distal mão E',
        },
        distalMao4D: {
          key: 'distalMao4D',
          label: '4ª Interfalangeana distal mão D',
        },
        distalMao4E: {
          key: 'distalMao4E',
          label: '4ª Interfalangeana distal mão E',
        },
        distalMao5D: {
          key: 'distalMao5D',
          label: '5ª Interfalangeana distal mão D',
        },
        distalMao5E: {
          key: 'distalMao5E',
          label: '5ª Interfalangeana distal mão E',
        },
        isquiaticaD: {
          key: 'isquiaticaD',
          label: 'Tuberosidade isquiática D',
        },
        isquiaticaE: {
          key: 'isquiaticaE',
          label: 'Tuberosidade isquiática E',
        },
        quadricepsD: {
          key: 'quadricepsD',
          label: 'Tendão do quadríceps D',
        },
        quadricepsE: {
          key: 'quadricepsE',
          label: 'Tendão do quadríceps E',
        },
        unha1quiroD: {
          key: 'unha1quiroD',
          label: 'Unha - 1º quirodáctilo D',
        },
        unha1quiroE: {
          key: 'unha1quiroE',
          label: 'Unha - 1º quirodáctilo E',
        },
        unha2quiroD: {
          key: 'unha2quiroD',
          label: 'Unha - 2º quirodáctilo D',
        },
        unha2quiroE: {
          key: 'unha2quiroE',
          label: 'Unha - 2º quirodáctilo E',
        },
        unha3quiroD: {
          key: 'unha3quiroD',
          label: 'Unha - 3º quirodáctilo D',
        },
        unha3quiroE: {
          key: 'unha3quiroE',
          label: 'Unha - 3º quirodáctilo E',
        },
        unha4quiroD: {
          key: 'unha4quiroD',
          label: 'Unha - 4º quirodáctilo D',
        },
        unha4quiroE: {
          key: 'unha4quiroE',
          label: 'Unha - 4º quirodáctilo E',
        },
        unha5quiroD: {
          key: 'unha5quiroD',
          label: 'Unha - 5º quirodáctilo D',
        },
        unha5quiroE: {
          key: 'unha5quiroE',
          label: 'Unha - 5º quirodáctilo E',
        },
        medialFemurD: {
          key: 'medialFemurD',
          label: 'Côndilo medial do fêmur D',
        },
        medialFemurE: {
          key: 'medialFemurE',
          label: 'Côndilo medial do fêmur E',
        },
        tendaoSupraD: {
          key: 'tendaoSupraD',
          label: 'Tendão supraespinhoso D',
        },
        tendaoSupraE: {
          key: 'tendaoSupraE',
          label: 'Tendão supraespinhoso E',
        },
        lateralFemurD: {
          key: 'lateralFemurD',
          label: 'Côndilo lateral do fêmur D',
        },
        lateralFemurE: {
          key: 'lateralFemurE',
          label: 'Côndilo lateral do fêmur E',
        },
        proximalMao1D: {
          key: 'proximalMao1D',
          label: '1ª Interfalangeana proximal mão D',
        },
        proximalMao1E: {
          key: 'proximalMao1E',
          label: '1ª Interfalangeana proximal mão E',
        },
        proximalMao2D: {
          key: 'proximalMao2D',
          label: '2ª Interfalangeana proximal mão D',
        },
        proximalMao2E: {
          key: 'proximalMao2E',
          label: '2ª Interfalangeana proximal mão E',
        },
        proximalMao3D: {
          key: 'proximalMao3D',
          label: '3ª Interfalangeana proximal mão D',
        },
        proximalMao3E: {
          key: 'proximalMao3E',
          label: '3ª Interfalangeana proximal mão E',
        },
        proximalMao4D: {
          key: 'proximalMao4D',
          label: '4ª Interfalangeana proximal mão D',
        },
        proximalMao4E: {
          key: 'proximalMao4E',
          label: '4ª Interfalangeana proximal mão E',
        },
        proximalMao5D: {
          key: 'proximalMao5D',
          label: '5ª Interfalangeana proximal mão D',
        },
        proximalMao5E: {
          key: 'proximalMao5E',
          label: '5ª Interfalangeana proximal mão E',
        },
        costocondral1D: {
          key: 'costocondral1D',
          label: '1ª costocondral D',
        },
        costocondral1E: {
          key: 'costocondral1E',
          label: '1ª costocondral E',
        },
        costocondral7D: {
          key: 'costocondral7D',
          label: '7ª costocondral D',
        },
        costocondral7E: {
          key: 'costocondral7E',
          label: '7ª costocondral E',
        },
        anteroSuperiorD: {
          key: 'anteroSuperiorD',
          label: 'Espinha ilíaca ântero-superior D',
        },
        anteroSuperiorE: {
          key: 'anteroSuperiorE',
          label: 'Espinha ilíaca ântero-superior E',
        },
        posteroSuperiorD: {
          key: 'posteroSuperiorD',
          label: 'Espinha ilíaca póstero-superior D',
        },
        posteroSuperiorE: {
          key: 'posteroSuperiorE',
          label: 'Espinha ilíaca póstero-superior E',
        },
        acromioclavicularD: {
          key: 'acromioclavicularD',
          label: 'Acromioclavicular D',
        },
        acromioclavicularE: {
          key: 'acromioclavicularE',
          label: 'Acromioclavicular E',
        },
        esternoclavicularD: {
          key: 'esternoclavicularD',
          label: 'Esternoclavicular D',
        },
        esternoclavicularE: {
          key: 'esternoclavicularE',
          label: 'Esternoclavicular E',
        },
        temporomandibularD: {
          key: 'temporomandibularD',
          label: 'Temporomandibular D',
        },
        temporomandibularE: {
          key: 'temporomandibularE',
          label: 'Temporomandibular E',
        },
      },
    }
  },
}
</script>

<style scoped>
.areas {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.ax-selectable {
  cursor: pointer;
  transition: all 0.1s ease-in-out;
}
.ax-selectable.hovered:not(.active) {
  fill: #9c9c9c;
}
.ax-label {
  position: fixed;
  background: #aaa021;
  color: white;
  padding: 4px 14px;
  font-size: 0.8rem;
  border-radius: 8px;
  box-shadow: 0 0 3px 0 #3a3a3a42;
  user-select: none;
}
.ax-thumbnails {
  display: flex;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item {
  height: 106px;
  width: 106px;
  border-radius: 5px;
  background: #e8e8e870;
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item:before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item.active {
  border: 2px solid #aba022;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item:hover {
  border: 2px solid rgba(171, 160, 34, 0.6);
}
.ax-thumbnails .ax-thumbs .ax-thumb-item:first-of-type {
  margin-top: 0;
}
.ax-selected-areas {
  padding: 1rem 1.8rem;
  border-left: 1px solid #dee2e6;
  width: 250px;
}
.ax-selected-areas > p {
  font-weight: bold;
}
.ax-selected-areas > ul {
  list-style: none;
  padding: 0;
  margin: 1.4rem 0;
}
.ax-selected-areas > ul > li {
  display: flex;
  justify-content: space-between;
  margin: 0 0 0.8rem;
}
.ax-selected-areas > ul > li > span {
  width: 100%;
}
.ax-selected-areas > ul > li > i {
  color: #e0e0e0;
  cursor: pointer;
}
.items-questions {
  align-self: center;
  height: fit-content;
}

.icon-page {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-7%);
  transform: translateY(-50%);
}

.answer-areas {
  background: #f6f6f6;
  padding-top: 0.1rem;
  padding-bottom: 0.7rem;
  margin-top: 0.5rem !important;
}

.answer-areas-position {
  margin-left: 40px;
}

.answer-text-position {
  margin-left: 25px;
}

body {
  color: #636c72;
}

body nick-checkbox .form-group,
.page-router-container nick-checkbox .form-group {
  margin: 0 !important;
  float: left;
  height: auto;
}

.form-group {
  margin-bottom: 0rem;
}

.page-router-container .nick-radio-options .nick-radio-option {
  width: 33.3333%;
  margin: 0px;
}

.ax-selected-areas {
  width: 300px;
}

label {
  margin-bottom: 0px;
}

.modal-dialog {
  max-width: 650px;
}

#items-wrapper {
  width: 100%;
}

#items {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

.item {
  flex: none;
  width: 100%;
  height: 100%;
  scroll-snap-align: start;
  pointer-events: none;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
